import { render, staticRenderFns } from "./BarChartInner.vue?vue&type=template&id=6b5e201c&scoped=true&lang=pug&"
import script from "./BarChartInner.vue?vue&type=script&lang=js&"
export * from "./BarChartInner.vue?vue&type=script&lang=js&"
import style0 from "./BarChartInner.vue?vue&type=style&index=0&id=6b5e201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e201c",
  null
  
)

export default component.exports